export enum LineHeight {
  default = '20px',
}
